import { createContext } from 'react';

const StoryContext = createContext(null);

export default StoryContext;
